/**
 * Created by Mohamed on 5/2/2016.
 */
(function(angular, _, TeamAPI) {

    var events = {
        "users_loaded": [],
        "user_deactivated": [],
        "user_locations_changed": [],
        "user_reactivated": []
    };

    var trigger = function (eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function (handler) {
            handler(param1, param2, param3, param4);
        });
    };

    var TSUsersService = function(TeamScheduleService, hUser, userManagementService) {

        var self = this;
        var requestDelayTimer;
        var usersToLoad = [];

        self.users = {};
        self.brandsUsers = {};
        self.brandsTeamUsers = {};
        self.businessTeamUsers = {};

        self.SCHEDULABLE = {
            NONE: 'NONE',
            REGULAR: 'REGULAR'
        };

        self.EMPLOYEE_VIEW_STATUS = {
            ACTIVE: 'ACTIVE',
            ALL: 'ALL'
        };

        self.onUsersLoaded = function (handler) {
            events["users_loaded"].push(handler);
        };

        self.onUserLocationsChanged = function (handler) {
            events["user_locations_changed"].push(handler);
        };

        self.onUsersDeactivated = function (handler) {
            events["user_deactivated"].push(handler);
        };

        self.onUsersReactivated = function (handler) {
            events["user_reactivated"].push(handler);
        };

        self.isUserInLoa = function (userId, date) {
            var user = self.users && self.users[userId];
            var effectiveDate = date || new Date().toDateString();

            if (user) {
                return user.hasEffectiveLOA(effectiveDate);
            }

            return false;
        }

        self.updateUserInfo = function (userId, userData) {
            if (self.users[userId]) {
                self.users[userId] = $.extend(self.users[userId], userData, true);
                trigger("users_loaded", [self.users[userId]]);
            }
        };

        self.getBrandTeamUsers = function (brandId, asArray, userStatus, schedulable) {
            var deferred = $q.defer();
            userStatus = userStatus || 'ACTIVE';
            var allBrandsTeamUsers = self.brandsTeamUsers[brandId] && self.brandsTeamUsers[brandId][userStatus] || {};
            var promises = {};

            if (Object.keys(allBrandsTeamUsers).length === 0) {
                promises['users'] = self.loadBrandUsers(brandId, asArray, userStatus, schedulable);
            }

            $q.all(promises)
                .then(function (res) {
                    allBrandsTeamUsers = self.brandsTeamUsers[brandId] && self.brandsTeamUsers[brandId][userStatus] || {};
                    var brandsTeamUsers = {};

                    for (var i in allBrandsTeamUsers) {
                        var user = allBrandsTeamUsers[i];

                        if (schedulable && user['schedulable'] !== schedulable) {
                            continue;
                        }

                        brandsTeamUsers[user.id] = user;
                    }

                    deferred.resolve(asArray? Object.values(brandsTeamUsers) : brandsTeamUsers);
                })
                .catch(function () {
                    deferred.resolve(asArray? [] : {});
                });

            return deferred.promise;
        };

        self.loadBusinessUsers = function (businessId, employeesIds, employersIds, asArray) {
            var deferred = $q.defer();
            $q.all({
                "users": TeamAPI.getBusinessUsers(businessId, employeesIds, employersIds),
                "settings": TeamScheduleService.getEmployeeBusinessSettings(businessId),
            }).then(function (res) {
                var tempUsers = res["users"];
                var userSettings = {employee_side_name_display_mode: res["settings"]["employee_side_name_display_mode"]};

                self.businessTeamUsers[businessId] = self.businessTeamUsers[businessId] || {};
                for (var i in tempUsers) {
                    var user = userManagementService.prepareUserDetails(tempUsers[i], userSettings);

                    if (!self.businessTeamUsers[businessId][user.id]) {
                        self.businessTeamUsers[businessId][user.id] = user;
                    }

                    self.users[user.id] = user;
                }
                deferred.resolve(asArray ? tempUsers : self.businessTeamUsers[businessId]);
            });
            return deferred.promise;
        };

        self.loadBrandUsers = function (brandId, asArray, userStatus, schedulable) {
            var deferred = $q.defer();
            userStatus = userStatus || 'ACTIVE';

            $q.all({
                "brand": TeamScheduleService.getActiveBrand(),
                "users": TeamAPI.getBrandEmployees(brandId, userStatus, schedulable)
            }).then(function (res) {
                var tempUsers = res["users"];
                var userSettings = {employee_side_name_display_mode: res["brand"]["employee_side_name_display_mode"]};
                self.brandsUsers[brandId] = self.brandsUsers[brandId] || {};
                self.brandsTeamUsers[brandId] = self.brandsTeamUsers[brandId] || {};
                self.brandsTeamUsers[brandId][userStatus] = self.brandsTeamUsers[brandId][userStatus] || {};

                for (var i in tempUsers) {
                    var user = userManagementService.prepareUserDetails(tempUsers[i], userSettings);

                    if (!self.brandsUsers[brandId][user.id]) {
                        self.brandsUsers[brandId][user.id] = user;
                    }

                    if (!self.brandsTeamUsers[brandId][userStatus][user.id]) {
                        self.brandsTeamUsers[brandId][userStatus][user.id] = user;
                    }

                    self.users[user.id] = user;
                }

                trigger("users_loaded", tempUsers);
                deferred.resolve(asArray? tempUsers: self.brandsUsers[brandId]);
            }).catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });

            return deferred.promise;
        };

        self.getActiveBrandTeamMembers = function () {
            var defer = $q.defer();

            TeamScheduleService.getActiveBrand().then(function (brand) {
                self.loadBrandUsers(brand.id, true).then(function (users) {
                    defer.resolve(users);
                });
            });

            return defer.promise;
        };

        let loadUsersPromises = [];

        self.loadUsers = function(brandId, usersIds, userStatus, schedulable) {

            var deferred = $q.defer();

			// Concat without duplicates
			usersToLoad = _.union(usersToLoad, usersIds);

			if (usersToLoad.length) {
                clearTimeout(requestDelayTimer);
                loadUsersPromises.push(deferred);

                requestDelayTimer = setTimeout(function () {
                    $q.all({
                        "brand": TeamScheduleService.getActiveBrand(),
                        "users": TeamAPI.getTeamMembers(brandId, usersToLoad, userStatus, schedulable)
                    }).then(function (res) {
                        var users = res["users"];
                        var userSettings = {employee_side_name_display_mode: res["brand"]["employee_side_name_display_mode"]};
                        self.brandsUsers[brandId] = self.brandsUsers[brandId] || {};

                        for (var i in users) {
                            users[i] = userManagementService.prepareUserDetails(users[i], userSettings);
                            self.users[users[i].id] = users[i];

                            if (!self.brandsUsers[brandId][users[i].id]) {
                                self.brandsUsers[brandId][users[i].id] = users[i];
                            }
                        }

                        trigger("users_loaded", users);

                        for (var i in loadUsersPromises) {
                            try {
                                loadUsersPromises[i].resolve(self.brandsUsers[brandId]);
                            } catch (e) {
                                console.error(e);
                            }
                        }

                        loadUsersPromises = [];
                    })
                        .catch(function (err) {
                            console.error("Failed to load user:", err);
                        });

                    usersToLoad = [];
                }, 300);
			}
            else {
                deferred.resolve([]);
            }

            return deferred.promise;
        };

        self.getUserInfo = function (brandId, userId) {
            var defer = $q.defer();

            if (self.users[userId]) {
                defer.resolve(self.users[userId]);
            } else {
                self.loadUsers(brandId, [userId])
                    .then(function () {
                        defer.resolve(self.users[userId]);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.isUserLoaded = function (brandId, user_id) {
            return self.users[user_id];
        };

        self.loadUserPayTypes = function(brandId, userId) {
            var deferred = $q.defer();

            var user = self.users[userId] || {};

            if (!user.pay_types) {
                TeamAPI.getTeamMembers(brandId, [userId], null, null, 'raw')
                    .then(function (userData) {
                        deferred.resolve(userData);
                    }, function (error) {
                        deferred.reject(error);
                    });
            } else {
                deferred.resolve(user);
            }

            return deferred.promise;
        };

        self.loadMemberDetails = function(brandId, userId, requiredData) {

            var deferred = $q.defer();

            if (userId) {
                $q.all({
                    "brand": TeamScheduleService.getActiveBrand(),
                    "users": TeamAPI.getTeamMembers(brandId, [userId], null, null, requiredData || 'detailed')
                }).then(function (res) {
                    var userSettings = {employee_side_name_display_mode: res["brand"]["employee_side_name_display_mode"]};
                    var user = userManagementService.prepareUserDetails(res["users"][0], userSettings);
                    self.users[user.id] = $.extend(true, user, self.users[user.id]);
                    self.brandsUsers[brandId] = self.brandsUsers[brandId] || {};
                    self.brandsUsers[brandId][user.id] = $.extend(true, user, self.brandsUsers[brandId][user.id]);
                    trigger("users_loaded", [user]);
                    deferred.resolve(self.brandsUsers[brandId]);
                }).catch(function (err) {
                    console.error(err);
                    deferred.reject(err);
                })
            }

            return deferred.promise;
        };

        self.getUserActivePayType = function (userId, date, viewType) {
            var activePayType = null;
            var formattedDate = moment(date).format("YYYY-MM-DD");

            if (self.users[userId].user_pay_types && self.users[userId].user_pay_types.length) {
                if (viewType === 'WEEKLY') {
                    var formattedEndWeekDate = moment(date).clone().add(6, 'days').format("YYYY-MM-DD");
                }

                for (var i in self.users[userId].user_pay_types) {
                    var payType = self.users[userId].user_pay_types[i];
                    if (payType.start_date && (
                        moment(formattedDate).isSameOrAfter(payType.start_date) ||
                        (formattedEndWeekDate && moment(formattedEndWeekDate).isSameOrAfter(payType.start_date))
                    )) {
                        activePayType = payType.type;
                        break;
                    }
                }
            }
            return activePayType;
        };

        self.loadMemberBasicInfo = function (brandId, userId) {

            var deferred = $q.defer();

            $q.all({
                "brand": TeamScheduleService.getActiveBrand(),
                "user": TeamAPI.getMemberBasicInfo(brandId, userId)
            }).then(function (res) {
                var user = res["user"];
                var userSettings = {employee_side_name_display_mode: res["brand"]["employee_side_name_display_mode"]};
                user = userManagementService.prepareUserDetails(user, userSettings);
                self.users[user.id] = $.extend(true, user, self.users[user.id]);
                self.brandsUsers[brandId] = self.brandsUsers[brandId] || {};
                self.brandsUsers[brandId][user.id] = $.extend(true, user, self.brandsUsers[brandId][user.id]);
                trigger("users_loaded", [user]);
                deferred.resolve(self.brandsUsers[brandId]);
            });

            return deferred.promise;
        };

        /**
         * This to make sure send event users updated when deactivate user
         *
         * @param brandId
         * @param userId
         */
        self.deactivateMember = function (brandId, userId) {
            var defer = $q.defer();

            TeamAPI
                .deactivateMember(brandId, userId)
                .then(function (data) {
                    self.users[userId].is_scheduling_member = false;
                    self.brandsUsers[brandId][userId].is_scheduling_member = false;

                    trigger("user_deactivated", [self.users[userId]]);

                    defer.resolve(data);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        self.reactivateMember = function (brandId, userId) {
            var defer = $q.defer();

            TeamAPI.reactivateMember(brandId, userId)
                .then(function (data) {
                    self.users[userId].is_scheduling_member = true;
                    self.brandsUsers[brandId][userId].is_scheduling_member = true;

                    trigger("user_reactivated", [self.users[userId]]);

                    defer.resolve(data);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        var loadingLocations = {};
        var locationsPromises = {};
        var usersLocations = {};

        self.updateUserActiveLocations = function (userId, userLocations) {
            usersLocations[hUser.getUserContext().brand_id][userId] = {brands: userLocations};
            var primaryLocation = userLocations.find(function (location) {
                return location.is_primary
            });

            TeamScheduleService.getActiveBrand().then(function (brand) {
                self.users[userId]['is_primary'] = (!userLocations.length || primaryLocation.id === brand.id);
                trigger("user_locations_changed", [usersLocations[hUser.getUserContext().brand_id][userId]]);
            });
        };

        self.getUserActiveLocations = function (userId, noCache) {
            var defer = $q.defer();

            if (noCache && usersLocations[hUser.getUserContext().brand_id]) {
                delete usersLocations[hUser.getUserContext().brand_id][userId];
            }

            if (usersLocations[hUser.getUserContext().brand_id] && usersLocations[hUser.getUserContext().brand_id][userId]) {
                defer.resolve(usersLocations[hUser.getUserContext().brand_id][userId]);
            }
            else {
                if (!loadingLocations[userId]) {
                    loadingLocations[userId] = true;

                    TeamAPI.getEmployeeActiveLocations(hUser.getUserContext().brand_id, userId)
                        .then(function (locations) {
                            usersLocations[hUser.getUserContext().brand_id] = usersLocations[hUser.getUserContext().brand_id] || {};
                            usersLocations[hUser.getUserContext().brand_id][userId] = locations;

                            for (var i in locationsPromises[userId]) {
                                locationsPromises[userId][i].resolve(locations);
                            }
                            delete locationsPromises[userId];
                            delete loadingLocations[userId];
                        }, function (err) {
                            for (var i in locationsPromises[userId]) {
                                locationsPromises[userId][i].reject(err);
                            }
                            delete locationsPromises[userId];
                            delete loadingLocations[userId];
                        });
                }

                locationsPromises[userId] = locationsPromises[userId] || [];
                locationsPromises[userId].push(defer);
            }

            return defer.promise;
        };
    };

    angular
        .module('harriApp')
        .service('TSUsersService', ['TeamScheduleService', 'hUser', 'userManagementService', TSUsersService]);

})(angular, _, TeamAPI);
